import React from 'react';

import { useGetIntegrations } from 'hooks/domain/integrations/useGetIntegrations';
import { useFeatureFlags } from 'hooks/useFeatureFlags';

import type { IntegrationState } from './types';
import { useHasShown } from './useHasShown';

export function useShowRealsatisfied(): IntegrationState {
  const integrations = useGetIntegrations();
  const { isRealSatisfiedEnabled } = useFeatureFlags();

  const shouldShow = React.useMemo(() => {
    const realsatisfied = integrations?.data?.realsatisfied;
    return (
      realsatisfied?.brokerEnablement === 'active' &&
      realsatisfied?.userEnablement === 'inactive' &&
      isRealSatisfiedEnabled
    );
  }, [integrations?.data?.realsatisfied, isRealSatisfiedEnabled]);

  const hasShown = useHasShown(shouldShow);

  return {
    show: shouldShow,
    isLoading: integrations.isLoading,
    hasShown,
  };
}
